(function(){"use strict";try{if(typeof document<"u"){var o=document.createElement("style");o.appendChild(document.createTextNode('@keyframes spinner-circle-animation-ed866313{0%,39%,to{opacity:0}40%{opacity:1}}.spinner[data-v-ed866313]{position:relative;width:var(--vs-spinner-size);height:var(--vs-spinner-size);margin:0;padding:0}.spinner-circle[data-v-ed866313]{width:100%;height:100%;position:absolute;left:0;top:0}.spinner-circle[data-v-ed866313]:before{content:"";display:block;margin:0 auto;width:15%;height:15%;background-color:var(--vs-spinner-color);border-radius:100%;-webkit-animation:spinner-circle-animation-ed866313 1.2s infinite ease-in-out both;animation:spinner-circle-animation-ed866313 1.2s infinite ease-in-out both}.spinner-circle[data-v-ed866313]:nth-child(2){transform:rotate(30deg)}.spinner-circle[data-v-ed866313]:nth-child(3){transform:rotate(60deg)}.spinner-circle[data-v-ed866313]:nth-child(4){transform:rotate(90deg)}.spinner-circle[data-v-ed866313]:nth-child(5){transform:rotate(120deg)}.spinner-circle[data-v-ed866313]:nth-child(6){transform:rotate(150deg)}.spinner-circle[data-v-ed866313]:nth-child(7){transform:rotate(180deg)}.spinner-circle[data-v-ed866313]:nth-child(8){transform:rotate(210deg)}.spinner-circle[data-v-ed866313]:nth-child(9){transform:rotate(240deg)}.spinner-circle[data-v-ed866313]:nth-child(10){transform:rotate(270deg)}.spinner-circle[data-v-ed866313]:nth-child(11){transform:rotate(300deg)}.spinner-circle[data-v-ed866313]:nth-child(12){transform:rotate(330deg)}.spinner-circle[data-v-ed866313]:nth-child(2):before{animation-delay:-1.1s}.spinner-circle[data-v-ed866313]:nth-child(3):before{animation-delay:-1s}.spinner-circle[data-v-ed866313]:nth-child(4):before{animation-delay:-.9s}.spinner-circle[data-v-ed866313]:nth-child(5):before{animation-delay:-.8s}.spinner-circle[data-v-ed866313]:nth-child(6):before{animation-delay:-.7s}.spinner-circle[data-v-ed866313]:nth-child(7):before{animation-delay:-.6s}.spinner-circle[data-v-ed866313]:nth-child(8):before{animation-delay:-.5s}.spinner-circle[data-v-ed866313]:nth-child(9):before{animation-delay:-.4s}.spinner-circle[data-v-ed866313]:nth-child(10):before{animation-delay:-.3s}.spinner-circle[data-v-ed866313]:nth-child(11):before{animation-delay:-.2s}.spinner-circle[data-v-ed866313]:nth-child(12):before{animation-delay:-.1s}.indicators-container[data-v-c1d96dfe]{display:flex;align-items:center;align-self:stretch;flex-shrink:0;gap:var(--vs-indicators-gap);padding:var(--vs-padding)}.clear-button[data-v-c1d96dfe]{appearance:none;display:inline-block;padding:0;margin:0;border:0;width:var(--vs-indicator-icon-size);height:var(--vs-indicator-icon-size);color:var(--vs-indicator-icon-color);background:none;outline:none;cursor:var(--vs-indicator-icon-cursor)}.dropdown-icon[data-v-c1d96dfe]{appearance:none;display:inline-block;padding:0;margin:0;border:0;width:var(--vs-indicator-icon-size);height:var(--vs-indicator-icon-size);color:var(--vs-indicator-icon-color);background:none;outline:none;cursor:var(--vs-indicator-icon-cursor);transition:var(--vs-indicator-dropdown-icon-transition)}.dropdown-icon.active[data-v-c1d96dfe]{transform:rotate(180deg)}.menu-option[data-v-00296627]{display:flex;width:var(--vs-option-width);border:0;margin:0;padding:var(--vs-option-padding);font-size:var(--vs-option-font-size);font-weight:var(--vs-option-font-weight);font-family:var(--vs-font-family);color:var(--vs-option-text-color);white-space:break-spaces;background-color:var(--vs-option-background-color);text-align:var(--vs-option-text-align);cursor:var(--vs-option-cursor)}.menu-option[data-v-00296627]:hover{background-color:var(--vs-option-hover-background-color);color:var(--vs-option-hover-text-color)}.menu-option.focused[data-v-00296627]{background-color:var(--vs-option-focused-background-color);color:var(--vs-option-focused-text-color)}.menu-option.selected[data-v-00296627]{background-color:var(--vs-option-selected-background-color);color:var(--vs-option-selected-text-color)}.menu-option.disabled[data-v-00296627]{background-color:var(--vs-option-disabled-background-color);color:var(--vs-option-disabled-text-color)}.multi-value[data-v-dfb6ab09]{display:flex;min-width:0px;margin:var(--vs-multi-value-margin);border-radius:var(--vs-multi-value-border-radius);background:var(--vs-multi-value-background-color)}.multi-value-label[data-v-dfb6ab09]{padding:var(--vs-multi-value-label-padding);border:var(--vs-multi-value-border);border-radius:var(--vs-multi-value-border-radius);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:var(--vs-multi-value-label-font-size);font-weight:var(--vs-multi-value-label-font-weight);line-height:var(--vs-multi-value-label-line-height);color:var(--vs-multi-value-label-text-color)}.multi-value-remove[data-v-dfb6ab09]{border-radius:var(--vs-multi-value-border-radius);appearance:none;display:flex;align-items:center;padding:var(--vs-multi-value-delete-padding);border:none;outline:none;cursor:var(--vs-multi-value-xmark-cursor);background-color:var(--vs-multi-value-background-color)}.multi-value-remove[data-v-dfb6ab09]:hover{background-color:var(--vs-multi-value-delete-hover-background-color)}.multi-value-remove svg[data-v-dfb6ab09]{width:var(--vs-multi-value-xmark-size);height:var(--vs-multi-value-xmark-size);fill:var(--vs-multi-value-xmark-color)}.multi-value-remove:hover svg[data-v-dfb6ab09]{fill:var(--vs-multi-value-xmark-hover-color)}.input-placeholder[data-v-a6f8261d]{grid-area:1 / 1 / 2 / 3;color:var(--vs-placeholder-color)}:root{--vs-width: 100%;--vs-min-height: 38px;--vs-padding: 4px 8px;--vs-border: 1px solid #e4e4e7;--vs-border-radius: 4px;--vs-font-size: 16px;--vs-font-weight: 400;--vs-font-family: inherit;--vs-text-color: #18181b;--vs-line-height: 1.5;--vs-placeholder-color: #52525b;--vs-background-color: #fff;--vs-disabled-background-color: #f4f4f5;--vs-outline-width: 1px;--vs-outline-color: #3b82f6;--vs-menu-offset-top: 8px;--vs-menu-height: 200px;--vs-menu-border: var(--vs-border);--vs-menu-background-color: var(--vs-background-color);--vs-menu-box-shadow: 0 1px 2px 0 rgb(0 0 0 / .05);--vs-menu-z-index: 2;--vs-option-width: 100%;--vs-option-padding: 8px 12px;--vs-option-cursor: pointer;--vs-option-font-size: var(--vs-font-size);--vs-option-font-weight: var(--vs-font-weight);--vs-option-text-align: -webkit-auto;--vs-option-text-color: var(--vs-text-color);--vs-option-hover-text-color: var(--vs-text-color);--vs-option-focused-text-color: var(--vs-text-color);--vs-option-selected-text-color: var(--vs-text-color);--vs-option-disabled-text-color: #52525b;--vs-option-background-color: var(--vs-menu-background);--vs-option-hover-background-color: #dbeafe;--vs-option-focused-background-color: var(--vs-option-hover-background-color);--vs-option-selected-background-color: #93c5fd;--vs-option-disabled-background-color: #f4f4f5;--vs-option-opacity-menu-open: .4;--vs-multi-value-margin: 2px;--vs-multi-value-border: 0px;--vs-multi-value-border-radius: 2px;--vs-multi-value-background-color: #f4f4f5;--vs-multi-value-label-padding: 4px 4px 4px 8px;--vs-multi-value-label-font-size: 12px;--vs-multi-value-label-font-weight: 400;--vs-multi-value-label-line-height: 1;--vs-multi-value-label-text-color: #3f3f46;--vs-multi-value-delete-padding: 0 3px;--vs-multi-value-delete-hover-background-color: #FF6467;--vs-multi-value-xmark-size: 16px;--vs-multi-value-xmark-cursor: pointer;--vs-multi-value-xmark-color: var(--vs-multi-value-label-text-color);--vs-multi-value-xmark-hover-color: #fff;--vs-indicators-gap: 0px;--vs-indicator-icon-size: 20px;--vs-indicator-icon-color: var(--vs-text-color);--vs-indicator-icon-cursor: pointer;--vs-indicator-dropdown-icon-transition: transform .2s ease-out;--vs-spinner-color: var(--vs-text-color);--vs-spinner-size: 16px}[data-v-3590fdf5]{box-sizing:border-box}.vue-select[data-v-3590fdf5]{position:relative;box-sizing:border-box;width:var(--vs-width)}.control[data-v-3590fdf5]{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;min-height:var(--vs-min-height);border:var(--vs-border);border-radius:var(--vs-border-radius);background-color:var(--vs-background-color)}.control.focused[data-v-3590fdf5]{box-shadow:0 0 0 var(--vs-outline-width) var(--vs-outline-color);border-color:var(--vs-outline-color)}.control.disabled[data-v-3590fdf5]{background-color:var(--vs-disabled-background-color)}.value-container[data-v-3590fdf5]{position:relative;overflow:hidden;display:grid;align-items:center;flex:1 1 0%;padding:var(--vs-padding)}.value-container.multi.has-value[data-v-3590fdf5]{display:flex;flex-wrap:wrap}.single-value[data-v-3590fdf5]{display:block;grid-area:1 / 1 / 2 / 3;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:var(--vs-font-size);font-weight:var(--vs-font-weight);font-family:var(--vs-font-family);line-height:var(--vs-line-height);color:var(--vs-text-color)}.vue-select[data-state=open] .single-value[data-v-3590fdf5]{opacity:var(--vs-option-opacity-menu-open)}.vue-select.typing .single-value[data-v-3590fdf5]{opacity:0}.input-container[data-v-3590fdf5]{visibility:visible;display:inline-grid;grid-area:1 / 1 / 2 / 3;grid-template-columns:0px min-content}.input-container.typing[data-v-3590fdf5]{transform:translateZ(0)}.input-container.typing[data-v-3590fdf5]:after{content:attr(data-value) " ";visibility:hidden;white-space:pre;grid-area:1 / 2;min-width:2px;padding:0;margin:0;border:0}.search-input[data-v-3590fdf5]{margin:0;padding:0;border:0;min-width:2px;width:100%;grid-area:1 / 2;background:0px center;font-size:var(--vs-font-size);font-family:var(--vs-font-family);line-height:var(--vs-line-height);color:var(--vs-text-color);opacity:1;outline:none}.menu[data-v-3590fdf5]{position:absolute;margin-top:var(--vs-menu-offset-top);max-height:var(--vs-menu-height);overflow-y:auto;border:var(--vs-menu-border);border-radius:var(--vs-border-radius);box-shadow:var(--vs-menu-box-shadow);background-color:var(--vs-menu-background-color);z-index:var(--vs-menu-z-index)}.no-results[data-v-3590fdf5]{padding:var(--vs-option-padding);font-size:var(--vs-font-size);font-family:var(--vs-font-family);color:var(--vs-text-color)}.taggable-no-options[data-v-3590fdf5]{padding:var(--vs-option-padding);font-size:var(--vs-font-size);font-family:var(--vs-font-family);color:var(--vs-text-color);cursor:pointer}')),document.head.appendChild(o)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { createElementBlock as f, openBlock as i, createElementVNode as $, Fragment as q, renderList as K, defineComponent as T, useTemplateRef as I, createCommentVNode as k, renderSlot as y, withModifiers as U, createVNode as L, normalizeClass as m, createBlock as A, ref as E, watch as W, withKeys as se, toDisplayString as R, mergeModels as G, useModel as oe, computed as J, onMounted as ie, onBeforeUnmount as ue, createTextVNode as N, withDirectives as re, vModelText as de, withCtx as F, Teleport as ce, normalizeStyle as pe, unref as Q } from "vue";
const B = (c, u) => {
  const l = c.__vccOpts || c;
  for (const [p, t] of u)
    l[p] = t;
  return l;
}, ve = {}, fe = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
function me(c, u) {
  return i(), f("svg", fe, u[0] || (u[0] = [
    $("path", {
      "fill-rule": "evenodd",
      d: "M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Y = /* @__PURE__ */ B(ve, [["render", me]]), be = {}, ye = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
};
function ge(c, u) {
  return i(), f("svg", ye, u[0] || (u[0] = [
    $("path", { d: "M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" }, null, -1)
  ]));
}
const z = /* @__PURE__ */ B(be, [["render", ge]]), he = {}, we = { className: "spinner" };
function $e(c, u) {
  return i(), f("div", we, [
    (i(), f(q, null, K(12, (l) => $("div", {
      key: l,
      class: "spinner-circle"
    })), 64))
  ]);
}
const ee = /* @__PURE__ */ B(he, [["render", $e], ["__scopeId", "data-v-ed866313"]]), Oe = {
  ref: "container",
  class: "indicators-container"
}, Me = ["disabled"], ke = ["disabled"], Be = /* @__PURE__ */ T({
  __name: "Indicators",
  props: {
    hasSelectedOption: { type: Boolean },
    isMenuOpen: { type: Boolean },
    isClearable: { type: Boolean },
    isLoading: { type: Boolean },
    isDisabled: { type: Boolean }
  },
  emits: ["clear", "toggle"],
  setup(c, { expose: u, emit: l }) {
    const p = l, t = I("container"), r = I("clearButton"), v = I("dropdownButton");
    return u({ containerRef: t, clearButtonRef: r, dropdownButtonRef: v }), (d, h) => (i(), f("div", Oe, [
      d.hasSelectedOption && d.isClearable && !d.isLoading ? (i(), f("button", {
        key: 0,
        ref: "clearButton",
        type: "button",
        class: "clear-button",
        tabindex: "-1",
        disabled: d.isDisabled,
        onClick: h[0] || (h[0] = U((o) => p("clear"), ["stop"]))
      }, [
        y(d.$slots, "clear", {}, () => [
          L(z)
        ], !0)
      ], 8, Me)) : k("", !0),
      d.isLoading ? k("", !0) : (i(), f("button", {
        key: 1,
        ref: "dropdownButton",
        type: "button",
        class: m(["dropdown-icon", { active: d.isMenuOpen }]),
        tabindex: "-1",
        disabled: d.isDisabled,
        onClick: h[1] || (h[1] = U((o) => p("toggle"), ["stop"]))
      }, [
        y(d.$slots, "dropdown", {}, () => [
          L(Y)
        ], !0)
      ], 10, ke)),
      y(d.$slots, "loading", {}, () => [
        d.isLoading ? (i(), A(ee, { key: 0 })) : k("", !0)
      ], !0)
    ], 512));
  }
}), Ce = /* @__PURE__ */ B(Be, [["__scopeId", "data-v-c1d96dfe"]]), De = ["aria-disabled", "aria-selected"], Ie = /* @__PURE__ */ T({
  __name: "MenuOption",
  props: {
    menu: {},
    index: {},
    isFocused: { type: Boolean },
    isSelected: { type: Boolean },
    isDisabled: { type: Boolean }
  },
  emits: ["select"],
  setup(c, { emit: u }) {
    const l = c, p = u, t = E(null);
    return W(
      () => l.isFocused,
      () => {
        if (l.isFocused && l.menu) {
          const r = l.menu.children[l.index], v = r.offsetTop, d = v + r.clientHeight, h = l.menu.scrollTop, o = l.menu.clientHeight;
          v < h ? l.menu.scrollTop = v : d > h + o && (l.menu.scrollTop = d - o);
        }
      }
    ), (r, v) => (i(), f("div", {
      ref_key: "option",
      ref: t,
      class: m(["menu-option", { focused: r.isFocused, selected: r.isSelected, disabled: r.isDisabled }]),
      tabindex: "-1",
      role: "option",
      "aria-disabled": r.isDisabled,
      "aria-selected": r.isSelected,
      onClick: v[0] || (v[0] = (d) => p("select")),
      onKeydown: v[1] || (v[1] = se((d) => p("select"), ["enter"]))
    }, [
      y(r.$slots, "default", {}, void 0, !0)
    ], 42, De));
  }
}), Le = /* @__PURE__ */ B(Ie, [["__scopeId", "data-v-00296627"]]), Ve = ["aria-label"], Se = /* @__PURE__ */ T({
  __name: "MultiValue",
  props: {
    label: {},
    classes: {}
  },
  emits: ["remove"],
  setup(c, { emit: u }) {
    const l = c, p = u;
    return (t, r) => (i(), f("div", {
      class: m(["multi-value", l.classes?.multiValue])
    }, [
      $("div", {
        class: m(["multi-value-label", l.classes?.multiValueLabel])
      }, R(l.label), 3),
      $("button", {
        type: "button",
        class: m(["multi-value-remove", l.classes?.multiValueRemove]),
        "aria-label": `Remove ${l.label}`,
        onClick: r[0] || (r[0] = U((v) => p("remove"), ["stop"]))
      }, [
        L(z)
      ], 10, Ve)
    ], 2));
  }
}), Ae = /* @__PURE__ */ B(Se, [["__scopeId", "data-v-dfb6ab09"]]), Re = { class: "input-placeholder" }, Te = /* @__PURE__ */ T({
  __name: "Placeholder",
  props: {
    text: {}
  },
  setup(c) {
    return (u, l) => (i(), f("div", Re, R(u.text), 1));
  }
}), _e = /* @__PURE__ */ B(Te, [["__scopeId", "data-v-a6f8261d"]]);
let Ne = 0;
function Fe() {
  return ++Ne;
}
const Ee = ["data-state"], Pe = ["id", "aria-expanded", "aria-describedby", "aria-description", "aria-labelledby", "aria-label", "aria-required", "aria-owns", "aria-controls"], qe = ["data-value"], Ke = ["id", "aria-labelledby", "disabled"], Ue = ["id", "aria-label", "aria-multiselectable"], We = /* @__PURE__ */ T({
  __name: "Select",
  props: /* @__PURE__ */ G({
    options: {},
    displayedOptions: {},
    placeholder: { default: "Select an option" },
    isClearable: { type: Boolean, default: !0 },
    isDisabled: { type: Boolean, default: !1 },
    isSearchable: { type: Boolean, default: !0 },
    isMulti: { type: Boolean, default: !1 },
    isTaggable: { type: Boolean, default: !1 },
    isLoading: { type: Boolean, default: !1 },
    isMenuOpen: { type: Boolean, default: void 0 },
    hideSelectedOptions: { type: Boolean, default: !0 },
    shouldAutofocusOption: { type: Boolean, default: !0 },
    closeOnSelect: { type: Boolean, default: !0 },
    teleport: { default: void 0 },
    inputId: { default: void 0 },
    classes: { default: void 0 },
    uid: { default: Fe() },
    aria: { default: void 0 },
    disableInvalidVModelWarn: { type: Boolean, default: !1 },
    filterBy: { type: Function, default: (c, u, l) => u.toLowerCase().includes(l.toLowerCase()) },
    getOptionValue: { type: Function, default: (c) => c.value },
    getOptionLabel: { type: Function, default: (c) => c.label }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ G(["optionSelected", "optionDeselected", "optionCreated", "menuOpened", "menuClosed", "search"], ["update:modelValue"]),
  setup(c, { emit: u }) {
    const l = c, p = u, t = oe(c, "modelValue"), r = I("container"), v = I("input"), d = I("menu"), h = I("indicators"), o = E(""), b = E(!1), V = E(-1), O = J(() => {
      const e = l.displayedOptions || l.options;
      e?.length || console.warn("[vue3-select-component warn]: No options or displayedOptions were provided to the component.");
      const n = e.map((s) => ({
        ...s,
        label: l.getOptionLabel(s),
        value: l.getOptionValue(s)
      })), a = (s) => s.filter(
        (w) => l.hideSelectedOptions && Array.isArray(t.value) ? !t.value.includes(w.value) : !0
      );
      if (l.isSearchable && o.value) {
        const s = n.filter((w) => l.filterBy(w, l.getOptionLabel(w), o.value));
        return l.isMulti ? a(s) : s;
      }
      return l.isMulti ? a(n) : n;
    }), g = J(() => {
      if (l.isMulti)
        return Array.isArray(t.value) ? t.value.map((n) => l.options.find((a) => l.getOptionValue(a) === n)).filter((n) => n !== void 0) : (l.disableInvalidVModelWarn || console.warn(`[vue3-select-component warn]: The v-model provided should be an array when using \`isMulti\` prop, instead it was: ${t.value}`), []);
      const e = l.options.find((n) => l.getOptionValue(n) === t.value);
      return e ? [e] : [];
    });
    function C() {
      l.isDisabled || (b.value = !0, l.shouldAutofocusOption && (V.value = l.options.findIndex((e) => !e.disabled)), v.value && v.value.focus(), p("menuOpened"));
    }
    function M() {
      b.value = !1, o.value = "", p("menuClosed");
    }
    function le() {
      b.value ? M() : C();
    }
    function te(e) {
      h.value?.containerRef && !h.value.containerRef.contains(e.target) && C();
    }
    const P = (e) => {
      e.disabled || (l.isMulti ? Array.isArray(t.value) ? t.value.find((a) => a === e.value) ? t.value = t.value.filter((a) => a !== e.value) : t.value.push(e.value) : (t.value = [e.value], l.disableInvalidVModelWarn || console.warn(`[vue3-select-component warn]: The v-model provided should be an array when using \`isMulti\` prop, instead it was: ${t.value}. Since an option has been selected, the component automatically converted the v-model to an array.`)) : t.value = e.value, p("optionSelected", e), o.value = "", l.closeOnSelect && M(), v.value && v.value.blur());
    }, H = (e) => {
      l.isMulti && !l.isDisabled && (Array.isArray(t.value) ? (t.value = t.value.filter((n) => n !== e.value), p("optionDeselected", e)) : l.disableInvalidVModelWarn || console.warn(`[vue3-select-component warn]: The v-model provided should be an array when using \`isMulti\` prop, instead it was: ${t.value}`));
    }, ae = () => {
      l.isMulti ? (t.value = [], p("optionDeselected", null)) : (t.value = void 0, p("optionDeselected", g.value[0])), M(), v.value && v.value.blur();
    }, Z = () => {
      p("optionCreated", o.value), o.value = "", M();
    }, j = (e) => {
      if (b.value) {
        const n = V.value;
        if (e.key === "ArrowDown") {
          e.preventDefault();
          const s = O.value.findIndex((D, S) => !D.disabled && S > n), w = O.value.findIndex((D) => !D.disabled);
          V.value = s === -1 ? w : s;
        }
        if (e.key === "ArrowUp") {
          e.preventDefault();
          const s = O.value.reduce(
            (D, S, _) => !S.disabled && _ < n ? _ : D,
            -1
          ), w = O.value.reduce(
            (D, S, _) => S.disabled ? D : _,
            -1
          );
          V.value = s === -1 ? w : s;
        }
        if (e.key === "Enter") {
          const s = O.value[n];
          e.preventDefault(), s ? P(s) : l.isTaggable && o.value && Z();
        }
        if (e.code === "Space" && o.value.length === 0) {
          const s = O.value[n];
          e.preventDefault(), s && P(s);
        }
        e.key === "Escape" && (e.preventDefault(), M());
        const a = l.isMulti && Array.isArray(t.value) ? t.value.length > 0 : !!t.value;
        e.key === "Backspace" && o.value.length === 0 && a && (e.preventDefault(), l.isMulti && Array.isArray(t.value) ? t.value = t.value.slice(0, -1) : t.value = void 0);
      }
    }, ne = (e) => {
      e.key === "Tab" ? M() : e.code === "Space" && !b.value && o.value.length === 0 && (e.preventDefault(), e.stopImmediatePropagation(), C());
    }, x = (e) => {
      const n = e.target, a = r.value && r.value.contains(n), s = d.value && d.value.contains(n);
      !a && !s && M();
    }, X = () => {
      if (r.value) {
        const e = r.value.getBoundingClientRect();
        return {
          left: `${e.x}px`,
          top: `${e.y + e.height}px`
        };
      }
      return console.warn("Unable to calculate dynamic menu position because of missing internal DOM reference."), { top: "0px", left: "0px" };
    };
    return W(
      () => o.value,
      () => {
        p("search", o.value), o.value && !b.value && C();
      }
    ), W(
      () => l.isMenuOpen,
      (e) => {
        e ? C() : M();
      },
      { immediate: !0 }
    ), ie(() => {
      document.addEventListener("mousedown", x), document.addEventListener("keydown", j);
    }), ue(() => {
      document.removeEventListener("mousedown", x), document.removeEventListener("keydown", j);
    }), (e, n) => (i(), f("div", {
      ref: "container",
      dir: "auto",
      class: m(["vue-select", [{ open: b.value, typing: b.value && o.value.length > 0, disabled: e.isDisabled }, l.classes?.container]]),
      "data-state": b.value ? "open" : "closed"
    }, [
      $("div", {
        class: m(["control", [{ focused: b.value, disabled: l.isDisabled }, l.classes?.control]]),
        onClick: n[3] || (n[3] = (a) => te(a))
      }, [
        $("div", {
          id: `vue-select-${e.uid}-combobox`,
          class: m(["value-container", [{ multi: e.isMulti, "has-value": g.value.length > 0 }, l.classes?.valueContainer]]),
          role: "combobox",
          "aria-expanded": b.value,
          "aria-describedby": e.placeholder,
          "aria-description": e.placeholder,
          "aria-labelledby": e.aria?.labelledby,
          "aria-label": g.value.length ? g.value.map(e.getOptionLabel).join(", ") : "",
          "aria-required": e.aria?.required,
          "aria-owns": `vue-select-${e.uid}-listbox`,
          "aria-controls": `vue-select-${e.uid}-listbox`,
          "aria-haspopup": "true"
        }, [
          !g.value[0] && !o.value.length ? (i(), A(_e, {
            key: 0,
            text: e.placeholder,
            class: m(l.classes?.placeholder)
          }, null, 8, ["text", "class"])) : !l.isMulti && g.value[0] ? (i(), f("div", {
            key: 1,
            class: m(["single-value", [l.classes?.singleValue]]),
            onClick: n[0] || (n[0] = (a) => C())
          }, [
            y(e.$slots, "value", {
              option: g.value[0]
            }, () => [
              N(R(e.getOptionLabel(g.value[0])), 1)
            ], !0)
          ], 2)) : l.isMulti && g.value.length ? (i(!0), f(q, { key: 2 }, K(g.value, (a) => y(e.$slots, "tag", {
            key: a.value,
            option: a,
            removeOption: () => H(a)
          }, () => [
            L(Ae, {
              label: e.getOptionLabel(a),
              classes: {
                multiValue: l.classes?.multiValue,
                multiValueLabel: l.classes?.multiValueLabel,
                multiValueRemove: l.classes?.multiValueRemove
              },
              onRemove: (s) => H(a)
            }, null, 8, ["label", "classes", "onRemove"])
          ], !0)), 128)) : k("", !0),
          $("div", {
            class: m(["input-container", [{ typing: b.value && o.value.length > 0 }, l.classes?.inputContainer]]),
            "data-value": o.value
          }, [
            re($("input", {
              id: e.inputId,
              ref: "input",
              "onUpdate:modelValue": n[1] || (n[1] = (a) => o.value = a),
              class: m(["search-input", l.classes?.searchInput]),
              autocapitalize: "none",
              autocomplete: "off",
              autocorrect: "off",
              spellcheck: "false",
              tabindex: "0",
              type: "text",
              "aria-autocomplete": "list",
              "aria-labelledby": `vue-select-${e.uid}-combobox`,
              disabled: e.isDisabled,
              placeholder: "",
              onMousedown: n[2] || (n[2] = (a) => C()),
              onKeydown: ne
            }, null, 42, Ke), [
              [de, o.value]
            ])
          ], 10, qe)
        ], 10, Pe),
        L(Ce, {
          ref: "indicators",
          "has-selected-option": g.value.length > 0,
          "is-menu-open": b.value,
          "is-clearable": e.isClearable,
          "is-loading": e.isLoading,
          "is-disabled": e.isDisabled,
          onClear: ae,
          onToggle: le
        }, {
          clear: F(() => [
            y(e.$slots, "clear", {}, () => [
              L(z)
            ], !0)
          ]),
          dropdown: F(() => [
            y(e.$slots, "dropdown", {}, () => [
              L(Y)
            ], !0)
          ]),
          loading: F(() => [
            y(e.$slots, "loading", {}, () => [
              e.isLoading ? (i(), A(ee, { key: 0 })) : k("", !0)
            ], !0)
          ]),
          _: 3
        }, 8, ["has-selected-option", "is-menu-open", "is-clearable", "is-loading", "is-disabled"])
      ], 2),
      (i(), A(ce, {
        to: e.teleport,
        disabled: !e.teleport,
        defer: !0
      }, [
        b.value ? (i(), f("div", {
          key: 0,
          id: `vue-select-${e.uid}-listbox`,
          ref: "menu",
          class: m(["menu", l.classes?.menuContainer]),
          role: "listbox",
          "aria-label": e.aria?.labelledby,
          "aria-multiselectable": e.isMulti,
          style: pe({
            width: l.teleport ? `${Q(r)?.getBoundingClientRect().width}px` : "100%",
            top: l.teleport ? X().top : "unset",
            left: l.teleport ? X().left : "unset"
          })
        }, [
          y(e.$slots, "menu-header", {}, void 0, !0),
          (i(!0), f(q, null, K(O.value, (a, s) => (i(), A(Le, {
            key: s,
            type: "button",
            menu: Q(d),
            index: s,
            "is-focused": V.value === s,
            "is-selected": Array.isArray(t.value) ? t.value.includes(a.value) : a.value === t.value,
            "is-disabled": a.disabled || !1,
            class: m(l.classes?.menuOption),
            onSelect: (w) => P(a)
          }, {
            default: F(() => [
              y(e.$slots, "option", {
                option: a,
                index: s,
                isFocused: V.value === s,
                isSelected: Array.isArray(t.value) ? t.value.includes(a.value) : a.value === t.value,
                isDisabled: a.disabled || !1
              }, () => [
                N(R(e.getOptionLabel(a)), 1)
              ], !0)
            ]),
            _: 2
          }, 1032, ["menu", "index", "is-focused", "is-selected", "is-disabled", "class", "onSelect"]))), 128)),
          !e.isTaggable && O.value.length === 0 ? (i(), f("div", {
            key: 0,
            class: m(["no-results", l.classes?.noResults])
          }, [
            y(e.$slots, "no-options", {}, () => [
              n[4] || (n[4] = N(" No results found "))
            ], !0)
          ], 2)) : k("", !0),
          e.isTaggable && o.value ? (i(), f("div", {
            key: 1,
            class: m(["taggable-no-options", l.classes?.taggableNoOptions]),
            onClick: Z
          }, [
            y(e.$slots, "taggable-no-options", { option: o.value }, () => [
              N(" Press enter to add " + R(o.value) + " option ", 1)
            ], !0)
          ], 2)) : k("", !0)
        ], 14, Ue)) : k("", !0)
      ], 8, ["to", "disabled"]))
    ], 10, Ee));
  }
}), He = /* @__PURE__ */ B(We, [["__scopeId", "data-v-3590fdf5"]]);
export {
  He as default
};
